import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { OnboardMedicalAidScreen } from 'screens/patient';

export default withPermissions(OnboardMedicalAidScreen, [
  GroupSecurity.PatientCreate,
]);
